import { cx } from '@emotion/css';
import { p2Css } from '@snapchat/snap-design-system-marketing';
import type { FC, ReactNode } from 'react';

import { LensStudioPlatformTag } from './LensStudioPlatformTag';
import {
  platformsLabelCss,
  supportedPlatformsContainerCss,
  tagsContainerCss,
} from './SupportedPlatforms.styles';
import type { LensStudioPlatform } from './types';
interface SupportedPlatformsProps {
  platforms: LensStudioPlatform[];
  supportedPlatformsLabel?: ReactNode;
}

export const SupportedPlatforms: FC<SupportedPlatformsProps> = ({
  platforms,
  supportedPlatformsLabel,
}) => {
  return (
    <div className={supportedPlatformsContainerCss}>
      {supportedPlatformsLabel && (
        <div className={cx(p2Css, platformsLabelCss)}>{supportedPlatformsLabel}</div>
      )}
      <div className={tagsContainerCss}>
        {platforms.map(platform => (
          <LensStudioPlatformTag key={platform.name} {...platform} />
        ))}
      </div>
    </div>
  );
};
